import { bindActionCreators } from "redux";
import * as commonData from "../Common";
import { getNoteBoard } from "./AddNote";
import { getBoardHistory } from "./update-single-row";
import * as actionType from "../constants";

const updateAttachmentData =
  (inputs, any = null) =>
  async (dispatch) => {
    const url = commonData.commonData().apiUrl;
    let newdata;
    if (inputs.hasOwnProperty("custom_note_uuid")) {
      const { customer_tattle_uuid, ...rest } = inputs;
      newdata = rest;
    } else {
      newdata = inputs;
    }
    try {
      const response = await fetch(`${url}update-attachment-data`, {
        method: "post",
        body: JSON.stringify(newdata),
      });
      const data = await response.json();
      if (data.code === 200) {
        dispatch(
          getNoteBoard(
            {
              app_token: inputs.app_token,
              attribute_set_key: inputs.attribute_set_key,
              customer_tattle_uuid: inputs.customer_tattle_uuid,
            },
            "status"
          )
        );
        dispatch(
          getBoardHistory(
            {
              app_token: inputs.app_token,
              attribute_set_key: inputs.attribute_set_key,
              customer_tattle_uuid: inputs.customer_tattle_uuid,
            },
            "status"
          )
        );
        if (inputs.hasOwnProperty("custom_note_uuid")) {
          dispatch(
            {
              type: actionType.ADD_IMAGE_TO_NOTE,
              payload: {
                attachment: inputs.attachment,
                custom_note_uuid: inputs.custom_note_uuid,
              },
            },
            any
          );
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

export default updateAttachmentData;
